import { render, staticRenderFns } from "./muokkaa-koulutussuunnitelma.vue?vue&type=template&id=262dad56&scoped=true&"
import script from "./muokkaa-koulutussuunnitelma.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-koulutussuunnitelma.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-koulutussuunnitelma.vue?vue&type=style&index=0&id=262dad56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262dad56",
  null
  
)

export default component.exports